export type IndexedDbUpgradeHandler = (
  db: IDBDatabase,
  request: IDBOpenDBRequest,
  event: IDBVersionChangeEvent
) => void;

export function openIndexedDb(
  name: string,
  version: number,
  onUpgrade?: IndexedDbUpgradeHandler
): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(name, version);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      if (onUpgrade) {
        onUpgrade(request.result, request, event);
      }
    };
  });
}

export function requestToPromise<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
}

export function transactionDone(tx: IDBTransaction): Promise<void> {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}
